import type { ObservationEntity } from "@/entities/observation";

import { useGetObservationRiskMatrix } from "@/entities/observation";
import { RiskTag } from "@/modules/risk-tag";

export type ObservationRiskTagProps = {
  observation: ObservationEntity;
};

const ObservationRiskTag = ({ observation }: ObservationRiskTagProps) => {
  const { risk } = useGetObservationRiskMatrix(observation);

  return <RiskTag risk={risk} />;
};

export default ObservationRiskTag;
